var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUserLock = function SvgUserLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.833 87.5v-8.333A16.667 16.667 0 0 0 54.167 62.5H20.833A16.667 16.667 0 0 0 4.167 79.167V87.5M37.5 45.833c9.205 0 16.667-7.462 16.667-16.666 0-9.205-7.462-16.667-16.667-16.667-9.205 0-16.667 7.462-16.667 16.667 0 9.204 7.462 16.666 16.667 16.666ZM88.542 35.417v-7.292a7.292 7.292 0 0 0-14.584 0v7.292m-.625 16.666h15.834c2.333 0 3.5 0 4.391-.454a4.167 4.167 0 0 0 1.821-1.82c.454-.892.454-2.059.454-4.392v-3.334c0-2.333 0-3.5-.454-4.391a4.167 4.167 0 0 0-1.82-1.821c-.892-.454-2.059-.454-4.392-.454H73.333c-2.333 0-3.5 0-4.391.454a4.167 4.167 0 0 0-1.821 1.82c-.454.892-.454 2.059-.454 4.392v3.334c0 2.333 0 3.5.454 4.391a4.167 4.167 0 0 0 1.82 1.821c.892.454 2.059.454 4.392.454Z",
    stroke: "currentColor",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgUserLock;